import { useEffect, useState } from 'react';
export function useBehaviorSubjectValue(subject$) {
    const [value, setValue] = useState(subject$.value);
    useEffect(() => {
        const subscription = subject$.subscribe(setValue);
        return () => subscription.unsubscribe();
    }, [subject$]);
    return value;
}
